module.exports = __webpack_public_path__ + "static/media/arrow_down_blue.ce60aef1.svg";